import { api } from './client';

export interface ResellerApplication {
  id: number;
  user_id: number | null;
  company: string;
  tax_id?: string;
  city?: string;
  email: string;
  phone?: string;
  monthly_volume?: string;
  categories: string[];
  message?: string;
  status: 'pending' | 'approved' | 'rejected';
  admin_notes?: string;
  created_at: string;
  updated_at?: string;
}

export interface CreateResellerRequest {
  company: string;
  tax_id?: string;
  city?: string;
  email: string;
  phone?: string;
  monthly_volume?: string;
  categories: string[];
  message?: string;
}

export const resellerApi = {
  submitApplication: (data: CreateResellerRequest) =>
    api.post<ResellerApplication>('/reseller-applications/', data),

  getApplications: () =>
    api.get<ResellerApplication[]>('/reseller-applications/'),

  getApplication: (id: number) =>
    api.get<ResellerApplication>(`/reseller-applications/${id}/`),

  updateApplication: (id: number, status: string, adminNotes?: string) =>
    api.patch<ResellerApplication>(`/reseller-applications/${id}/`, { status, admin_notes: adminNotes }),
};
